import { createFileRoute, useParams } from '@tanstack/react-router';

import { VStack } from '@/components/Layout';
import { PeopleGroupDetail } from '@/features/people-group/-components/PeopleGroupDetail/PeopleGroupDetail';

import HeaderDetailPeopleGroup from './-components/HeaderDetailPeopleGroup';

export const Route = createFileRoute(
  '/_staff/settings/permission-and-roles/_detail/people-groups/$id/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id: peopleGroupId } = useParams({
    from: '/_staff/settings/permission-and-roles/_detail/people-groups/$id/',
  });

  return (
    <VStack>
      <HeaderDetailPeopleGroup peopleGroupId={peopleGroupId} />
      <VStack className="gap-7 p-10">
        <PeopleGroupDetail peopleGroupId={peopleGroupId} />
      </VStack>
    </VStack>
  );
}
